import React, { useEffect, useRef, useState } from 'react';
import { Helmet } from "react-helmet-async";
import { Container } from '@mui/material';
import { GridView, Language, RocketLaunch, WebAsset, PhoneIphone } from '@mui/icons-material';
import { usePageTransition } from '../context/PageTransitionContext.tsx';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import './lavori.scss';

gsap.registerPlugin(ScrollTrigger);

type FilterType = 'tutti' | 'siti-web' | 'landing-page' | 'web-app' | 'mobile-app';

interface Project {
  id: string;
  name: string;
  category: string;
  description: React.ReactNode;
  image: string;
  url?: string;
  tag: FilterType;
}

const projects: Project[] = [
  {
    id: 'selleria',
    name: 'La Selleria della Bassa',
    category: 'Sito Web • Next.js',
    description: 'Sviluppo e progettazione grafica completa per e-commerce custom.',
    image: '/lavori/siti/home_selleria.png',
    url: 'https://laselleriadellabassa.it/',
    tag: 'siti-web'
  },
  {
    id: 'charly',
    name: 'Circolo Ippico Charly',
    category: 'Sito Web',
    description: 'Sviluppo e prototipazione del sito vetrina del maneggio.',
    image: '/lavori/siti/home_charly.png',
    url: 'https://www.circoloippicocharly.it/',
    tag: 'siti-web'
  },
  {
    id: 'marumars',
    name: 'Martina Russo',
    category: 'Sito Web • Next.js',
    description: 'Sviluppo e prototipazione grafica per digital communication specialist.',
    image: '/lavori/siti/home_marumars.png',
    url: 'https://marumars.it/',
    tag: 'siti-web'
  },
  {
    id: 'monferrato',
    name: 'Monferrato Slow Stay',
    category: 'Sito Web • Next.js',
    description: 'Design e sviluppo del sito web per un B&B nel cuore del Monferrato, pensato per trasmettere calore e semplicità nella prenotazione.',
    image: '/lavori/siti/home_monferrato.png',
    url: 'https://www.monferratoslowstay.it/',
    tag: 'siti-web'
  },
  {
    id: 'fabbri',
    name: 'Fabbri Agricoltura',
    category: 'Sito Web • React',
    description: 'Progettazione grafica completa e sviluppo front-end.',
    image: '/lavori/siti/home_fabbri.png',
    url: 'https://www.fabbriagricoltura.it/',
    tag: 'siti-web'
  },
  {
    id: 'rugrafica',
    name: 'Ru Grafica',
    category: 'Sito Web • React',
    description: 'Sviluppo sito web per grafica freelance specializzato in branding e comunicazione visiva.',
    image: '/lavori/siti/home_rugrafica.png',
    url: 'https://www.sararuggeridesigner.it/',
    tag: 'siti-web'
  },
  {
    id: 'voltaren',
    name: 'Voltaren Studio',
    category: 'Sito Web • React',
    description: 'Sviluppo front-end e progettazione grafica su misura.',
    image: '/lavori/siti/home_voltaren.png',
    url: 'https://www.voltarenstudio.it/',
    tag: 'siti-web'
  },
  {
    id: 'refertosicuro',
    name: 'Referto Sicuro',
    category: 'Landing Page • Next.js',
    description: 'Landing page per prodotto di intelligenza artificiale di proprietà di IusMedical, dedicato alla validazione automatica dei referti medici.',
    image: '/lavori/siti/home_refertosicuro.png',
    url: 'https://refertosicuro.it/',
    tag: 'landing-page'
  },
  {
    id: 'iusmedical',
    name: 'IusMedical',
    category: 'Sito Web • React/Vite',
    description: 'Progettazione grafica completa e sviluppo front-end per un\'esperienza utente intuitiva e professionale.',
    image: '/lavori/siti/home_iusmedical.png',
    tag: 'siti-web'
  },
  {
    id: 'sacco',
    name: 'Sacco',
    category: 'Sito Web • WordPress',
    description: <>Sviluppo sito web realizzato per conto dell'agenzia <a href="https://www.linoolmostudio.it/" target="_blank" rel="noopener noreferrer">Lino Olmo Studio</a>, con tema custom su piattaforma Wordpress.</>,
    image: '/lavori/siti/home_sacco.png',
    url: 'https://www.sacco.it/',
    tag: 'siti-web'
  },
  {
    id: 'carpenteria',
    name: 'Carpenteria Maifredi',
    category: 'Sito Web • WordPress',
    description: <>Sviluppo sito web realizzato per conto dell'agenzia <a href="https://www.linoolmostudio.it/" target="_blank" rel="noopener noreferrer">Lino Olmo Studio</a>, con tema custom su piattaforma Wordpress.</>,
    image: '/lavori/siti/home_carpenteria.png',
    url: 'https://www.maifredicarpenteria.it/',
    tag: 'siti-web'
  },
  {
    id: 'stech',
    name: 'stech.',
    category: 'Sito Web • React',
    description: 'Sviluppo sito web e restyling grafico.',
    image: '/lavori/siti/home_stech.png',
    url: 'https://www.stech.technology/',
    tag: 'siti-web'
  },
  {
    id: 'polytech',
    name: 'Poly-Tech',
    category: 'Sito Web • React',
    description: 'Realizzazione design professionale e sviluppo sito web.',
    image: '/lavori/siti/home_polytech.png',
    url: 'https://www.poly-tech.it/',
    tag: 'siti-web'
  },
  {
    id: 'gumi',
    name: 'Gumi AI',
    category: 'Landing Page • React',
    description: 'Progettazione grafica e sviluppo landing page.',
    image: '/lavori/siti/home_gumi.png',
    url: 'https://www.gumi-ai.it/',
    tag: 'landing-page'
  },
  {
    id: '3anetwork',
    name: '3A Network',
    category: 'Sito Web • WordPress',
    description: 'Realizzazione grafica e sviluppo sito web.',
    image: '/lavori/siti/home_3anetwork.png',
    url: 'https://www.3anetwork.it/',
    tag: 'siti-web'
  },
  {
    id: 'flowly',
    name: 'Flowly',
    category: 'Web App • React',
    description: 'Gestionale custom per studi dentistici. Gestione pazienti, appuntamenti e fatturazione in un\'unica piattaforma.',
    image: '/lavori/crm/home_flowly.png',
    tag: 'web-app'
  },
  {
    id: 'agritech',
    name: 'Agritech',
    category: 'Web App • React',
    description: 'Gestionale custom sviluppato su misura per il cliente, gestisce le anagrafiche, ha un archivio, crea e spedisce via mail le bolle.',
    image: '/lavori/crm/home_agritech.png',
    tag: 'web-app'
  },
  {
    id: 'gigbeatle',
    name: 'GigBeatle',
    category: 'Mobile App',
    description: 'Cura e disegno dell\'interfaccia grafica.',
    image: '/lavori/mobile_app/gigbeatle.png',
    tag: 'mobile-app'
  }
];

const filters = [
  { label: 'Tutti', value: 'tutti' as FilterType, icon: <GridView /> },
  { label: 'Siti Web', value: 'siti-web' as FilterType, icon: <Language /> },
  { label: 'Landing Page', value: 'landing-page' as FilterType, icon: <RocketLaunch /> },
  { label: 'Web App', value: 'web-app' as FilterType, icon: <WebAsset /> },
  { label: 'Mobile App', value: 'mobile-app' as FilterType, icon: <PhoneIphone /> }
];

const mockups = [
  '/mockup/app/pink_commerce.png',
  '/mockup/app/spelly.png',
  '/mockup/app/universe_app.png'
];

function Lavori() {
  const { navigateWithTransition } = usePageTransition();
  const heroTitleRef = useRef<HTMLHeadingElement>(null);
  const videoRef = useRef<HTMLVideoElement>(null);
  const [activeFilter, setActiveFilter] = useState<FilterType>('tutti');
  const [currentSlide, setCurrentSlide] = useState(0);

  // Refs blob liquido
  const filtersContainerRef = useRef<HTMLDivElement>(null);
  const filterBtnsRef = useRef<(HTMLButtonElement | null)[]>([]);
  const [blobStyle, setBlobStyle] = useState({ left: 0, width: 0 });
  const [isAnimating, setIsAnimating] = useState(false);

  // Animazione contatori
  const statsRefDesktop = useRef<HTMLDivElement>(null);
  const statsRefMobile = useRef<HTMLDivElement>(null);
  const [counters, setCounters] = useState({ progetti: 0, clienti: 0, anni: 0 });
  const [hasAnimated, setHasAnimated] = useState(false);

  // Animazione contatori effect
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasAnimated) {
            setHasAnimated(true);

            const targets = { progetti: 50, clienti: 30, anni: 5 };
            const duration = 2000;
            const startTime = Date.now();

            const animate = () => {
              const elapsed = Date.now() - startTime;
              const progress = Math.min(elapsed / duration, 1);

              // Funzione easing (ease-out)
              const easeOut = 1 - Math.pow(1 - progress, 3);

              setCounters({
                progetti: Math.floor(easeOut * targets.progetti),
                clienti: Math.floor(easeOut * targets.clienti),
                anni: Math.floor(easeOut * targets.anni)
              });

              if (progress < 1) {
                requestAnimationFrame(animate);
              }
            };

            requestAnimationFrame(animate);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (statsRefDesktop.current) {
      observer.observe(statsRefDesktop.current);
    }
    if (statsRefMobile.current) {
      observer.observe(statsRefMobile.current);
    }

    return () => observer.disconnect();
  }, [hasAnimated]);

  const filteredProjects = activeFilter === 'tutti'
    ? projects
    : projects.filter(project => project.tag === activeFilter);

  // Aggiorna posizione blob
  const updateBlobPosition = (index: number) => {
    const btn = filterBtnsRef.current[index];
    const container = filtersContainerRef.current;
    if (btn && container) {
      const containerRect = container.getBoundingClientRect();
      const btnRect = btn.getBoundingClientRect();
      setBlobStyle({
        left: btnRect.left - containerRect.left,
        width: btnRect.width
      });
    }
  };

  // Imposta posizione iniziale blob e gestisce resize
  useEffect(() => {
    const activeIndex = filters.findIndex(f => f.value === activeFilter);
    updateBlobPosition(activeIndex);

    const handleResize = () => {
      const activeIndex = filters.findIndex(f => f.value === activeFilter);
      updateBlobPosition(activeIndex);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [activeFilter]);

  const handleFilterClick = (filter: FilterType, index: number) => {
    if (filter === activeFilter) return;
    setIsAnimating(true);
    setActiveFilter(filter);
    updateBlobPosition(index);
    // Resetta stato animazione al completamento
    setTimeout(() => setIsAnimating(false), 600);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % mockups.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + mockups.length) % mockups.length);
  };

  useEffect(() => {
    // Animazione titolo hero
    if (heroTitleRef.current) {
      const lines = heroTitleRef.current.querySelectorAll('.hero-line');
      gsap.fromTo(lines,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1.2,
          stagger: 0.15,
          ease: "power3.out",
          delay: 0.3
        }
      );
    }

    // Parallasse video
    const handleScroll = () => {
      if (videoRef.current) {
        const scrolled = window.pageYOffset;
        videoRef.current.style.transform = `translateY(${scrolled * 0.5}px) scale(1.1)`;
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Animazione cards
    const cards = document.querySelectorAll('.project-card');
    cards.forEach((card) => {
      gsap.fromTo(card,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power2.out",
          scrollTrigger: {
            trigger: card,
            start: "top 85%",
            toggleActions: "play none none none"
          }
        }
      );
    });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>Portfolio Siti Web | Lavori e Progetti Realizzati - Camilla Cino</title>
        <meta name="description" content="Portfolio web designer: scopri i siti web professionali che ho realizzato per PMI, freelance e aziende." />
        <meta name="keywords" content="portfolio web designer, siti web professionali, progetti realizzati, web design portfolio" />
        <meta property="og:title" content="Portfolio Siti Web | Lavori e Progetti Realizzati" />
        <meta property="og:description" content="Portfolio web designer: scopri i siti web professionali che ho realizzato." />
        <meta property="og:image" content="https://www.camillacinodesigndev.it/loghi/sito/preview.png" />
        <meta property="og:url" content="https://www.camillacinodesigndev.it/lavori" />
        <link rel="canonical" href="https://www.camillacinodesigndev.it/lavori" />
      </Helmet>

      <div className="lavori-page">
        {/* Hero Section */}
        <section className="lavori-hero">
          <video
            ref={videoRef}
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            suppressHydrationWarning
          >
            <source src="/video/video2.mp4" type="video/mp4" />
          </video>
          <div className="hero-overlay"></div>
          <div className="hero-bg"></div>
          <Container maxWidth="xl" className="hero-content">
            <div className="hero-label">
              <span className="label-line"></span>
              Portfolio
            </div>

            <h1 className="hero-title" ref={heroTitleRef}>
              <span className="hero-line">I miei</span>
              <span className="hero-line"><span className="gradient-text">Lavori</span></span>
            </h1>

            <p className="hero-description">
              Una selezione dei progetti che ho realizzato per clienti e agenzie.
              Ogni progetto è unico, pensato e sviluppato su misura.
            </p>

            {/* Stats Desktop - verticale a destra */}
            <div className="hero-stats-desktop" ref={statsRefDesktop} suppressHydrationWarning>
              <div className="stat-item" suppressHydrationWarning>
                <span className="stat-number" suppressHydrationWarning>{counters.progetti}+</span>
                <span className="stat-label">Progetti</span>
              </div>
              <div className="stat-item" suppressHydrationWarning>
                <span className="stat-number" suppressHydrationWarning>{counters.clienti}+</span>
                <span className="stat-label">Clienti</span>
              </div>
              <div className="stat-item" suppressHydrationWarning>
                <span className="stat-number" suppressHydrationWarning>{counters.anni}+</span>
                <span className="stat-label">Anni</span>
              </div>
            </div>

            <div className="hero-cta-group">
              <a
                href="#progetti"
                className="hero-cta"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('progetti')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Scopri i lavori
                <span className="arrow">↓</span>
              </a>
              <a
                href="#design-concept"
                className="hero-cta secondary"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('design-concept')?.scrollIntoView({ behavior: 'smooth' });
                }}
              >
                Design Concept
                <span className="arrow">↓</span>
              </a>
            </div>

            {/* Stats Mobile - orizzontale sotto CTA */}
            <div className="hero-stats-mobile" ref={statsRefMobile} suppressHydrationWarning>
              <div className="stat-item" suppressHydrationWarning>
                <span className="stat-number" suppressHydrationWarning>{counters.progetti}+</span>
                <span className="stat-label">Progetti</span>
              </div>
              <div className="stat-item" suppressHydrationWarning>
                <span className="stat-number" suppressHydrationWarning>{counters.clienti}+</span>
                <span className="stat-label">Clienti</span>
              </div>
              <div className="stat-item" suppressHydrationWarning>
                <span className="stat-number" suppressHydrationWarning>{counters.anni}+</span>
                <span className="stat-label">Anni</span>
              </div>
            </div>
          </Container>

          <div className="scroll-indicator">
            <div className="scroll-line"></div>
            <span>Scroll</span>
          </div>
        </section>

        {/* Projects Section */}
        <section className="projects-section" id="progetti">
          <Container maxWidth="xl">
            <div className="section-header">
              <h2 className="section-title">
                <span className="number">01</span>
                Progetti Realizzati
              </h2>
            </div>

            {/* Filters - Liquid Glass */}
            <div className="filters-container" ref={filtersContainerRef} suppressHydrationWarning>
              <div
                className={`filter-blob ${blobStyle.width > 0 ? 'visible' : ''}`}
                suppressHydrationWarning
                style={{
                  transform: `translateX(${blobStyle.left}px)`,
                  width: `${blobStyle.width}px`
                }}
              />
              {filters.map((filter, index) => (
                <button
                  key={filter.value}
                  ref={el => filterBtnsRef.current[index] = el}
                  className={`filter-btn ${activeFilter === filter.value ? 'active' : ''}`}
                  onClick={() => handleFilterClick(filter.value, index)}
                >
                  <span className="filter-icon">{filter.icon}</span>
                  <span className="filter-label">{filter.label}</span>
                </button>
              ))}
            </div>

            {/* Projects Grid */}
            <div className={`projects-grid ${isAnimating ? 'animating' : ''}`}>
              {filteredProjects.map((project, index) => (
                <div
                  key={`${activeFilter}-${project.id}`}
                  className="project-card"
                  style={{ '--delay': `${index * 0.08}s` } as React.CSSProperties}
                >
                  <div className="project-image">
                    <img src={project.image} alt={project.name} loading="lazy" />
                  </div>
                  <div className="project-info">
                    <span className="project-category">{project.category}</span>
                    <h3 className="project-name">{project.name}</h3>
                    <p className="project-description">{project.description}</p>
                    {project.url && (
                      <a href={project.url} target="_blank" rel="noopener noreferrer" className="project-link">
                        Visita il sito <span className="arrow">→</span>
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </Container>
        </section>

        {/* Design Concepts Section */}
        <section className="concepts-section" id="design-concept" style={{ backgroundImage: "url('/sfondi/sfondo2.png')" }}>
          <Container maxWidth="xl">
            <div className="section-header centered">
              <h2 className="section-title">
                <span className="number">02</span>
                Design Concept
              </h2>
            </div>

            <div className="concept-slider-container">
              <button className="concept-slider-btn prev" onClick={prevSlide}>‹</button>

              <div className="concept-slider-viewport">
                <div
                  className="concept-slider-track"
                  style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                  {mockups.map((mockup, index) => (
                    <div
                      key={index}
                      className="concept-slide"
                      style={{ backgroundImage: `url(${mockup})` }}
                    />
                  ))}
                </div>
              </div>

              <button className="concept-slider-btn next" onClick={nextSlide}>›</button>
            </div>

            <div className="concept-slider-dots">
              {mockups.map((_, index) => (
                <button
                  key={index}
                  className={`concept-dot ${currentSlide === index ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </Container>
        </section>

        {/* CTA Section */}
        <section className="cta-section">
          <Container maxWidth="lg">
            <h2 className="cta-title">
              Hai un progetto<br />
              <span className="glitch" data-text="ambizioso?">ambizioso?</span>
            </h2>
            <button
              className="hero-cta"
              onClick={() => navigateWithTransition('/contatti')}
            >
              Parliamone
              <span className="arrow">→</span>
            </button>
          </Container>
        </section>
      </div>
    </>
  );
}

export default Lavori;
